import { types } from './Alert.actions'
import { Alert } from 'services/alerts.service'

type AlertState = {
  alert: Alert | null
}

const INITIAL_STATE: AlertState = {
  alert: null
}

export default function alertReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case types.SET_ALERT:
      return { ...state, alert: action.payload.alert }
    case types.CLEAR_ALERT:
      return { ...state, alert: null }
    default:
      return state
  }
}
